{
  "profile_title": "Profile",
  "edit_profile_tab": "Edit profile",
  "password_tab": "Password",
  "company_tab": "Company",
  "payments_tab": "Payments",
  "team_members_tab": "Team members",
  "storage_quota_tab": "Storage quota",
  "company_name_label": "Company name",
  "vat_label": "VAT number",
  "line1_label": "Address",
  "line2_label": "Address cont.",
  "city_label": "City",
  "state_label": "State / Province",
  "zipCode_label": "Zip",
  "country_label": "Country",
  "company_submit": "save company information",
  "added_date": "Date d'ajout",
  "role": "Role",
  "invite_creators": "Inviter un membre",
  "send_invitation": "Envoyer l'invitation",
  "team_invitations_tab": "Pending invitations"
}
